const data = {
  title: "Notifications",
  notification: [],
};
export default data;
